import { MutationTree } from 'vuex';
import { SuiviFacturesAvantEcheanceState } from '.';
import { SUIVI_FACTURES_AVANT_ECHEANCE } from './mutation-types';
import { SortType } from '@/models/SortType';
import { SuiviFacture } from '@/models/SuiviFacture';

export const mutations: MutationTree<SuiviFacturesAvantEcheanceState> = {

    [SUIVI_FACTURES_AVANT_ECHEANCE.SET_SCROLL](state, scroll: number) {
        state.scroll = scroll;
    },

    [SUIVI_FACTURES_AVANT_ECHEANCE.SET_ITEMS_AVANT_ECHEANCE](state, items: SuiviFacture[]) {
        state.facturesAvantEcheance = items;
    },
    [SUIVI_FACTURES_AVANT_ECHEANCE.ADD_ITEMS](state, items: SuiviFacture[]) {
        state.facturesAvantEcheance = [...state.facturesAvantEcheance, ...items];
    },
    [SUIVI_FACTURES_AVANT_ECHEANCE.SET_PAGE_AVANT_ECHEANCE](state, page: number) {
        state.page = page;
    },
    [SUIVI_FACTURES_AVANT_ECHEANCE.SET_NB_OF_PAGES_AVANT_ECHEANCE](state, pages: number) {
        state.nbOfPages = pages;
    },
    [SUIVI_FACTURES_AVANT_ECHEANCE.SET_COUNT_AVANT_ECHEANCE](state, count: number) {
        state.count = count;
    },
    [SUIVI_FACTURES_AVANT_ECHEANCE.SET_SORT_AVANT_ECHEANCE](
        state,
        sort:
            | {
                  sortData: string;
                  sortType: SortType;
              }
            | undefined
    ) {
        state.sort = sort;
    },
    [SUIVI_FACTURES_AVANT_ECHEANCE.SET_IS_LOADING_AVANT_ECHEANCE](state, isLoading: boolean) {
        state.isLoading = isLoading;
    },
    [SUIVI_FACTURES_AVANT_ECHEANCE.SET_ERROR_AVANT_ECHEANCE](state, error: Error | undefined) {
        state.error = error;
    },

    [SUIVI_FACTURES_AVANT_ECHEANCE.RESET_ITEMS](state) {
        state.facturesAvantEcheance = [];
    },

};
